import React, { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { Bug } from "lucide-react";
import { getAppVersion } from "@/lib/appVersion";
import { videoNetworkDiag } from "@/lib/videoSource";
import { getDeviceId } from "@/lib/api";

// Admin › Paramètres › Système — infos techniques de CET appareil (hors interface membre) : version + versionCode,
// empreinte du code web, plateforme, identifiant d'appareil, diagnostic vidéo/réseau. Aide au debug uniquement.
export const DeviceDebugCard = () => {
  const [v, setV] = useState(null);
  useEffect(() => { getAppVersion().then(setV).catch(() => {}); }, []);
  const rows = [
    ["Version", v ? `${v.version}${v.build ? ` (versionCode ${v.build})` : ""}` : "…"],
    ["Code web", v?.web || "—"],
    ["Plateforme", `${Capacitor.getPlatform()}${Capacitor.isNativePlatform() ? " · app native" : " · navigateur"}`],
    ["Appareil", getDeviceId?.() || "—"],
    ["Vidéo / réseau", videoNetworkDiag() || "—"],
  ];
  return (
    <div className="yalola-card p-5 space-y-3" data-testid="device-debug-card">
      <div className="flex items-center gap-2">
        <Bug size={18} style={{ color: "var(--yalola-primary)" }} />
        <div>
          <div className="font-bold font-display text-lg">Cet appareil (debug)</div>
          <p className="text-sm" style={{ color: "var(--yalola-text-muted)" }}>Visible ici seulement — les membres ne voient que « Yalola {v?.version || "…"} » dans leurs Paramètres.</p>
        </div>
      </div>
      <dl className="text-sm grid gap-1.5" style={{ gridTemplateColumns: "max-content minmax(0, 1fr)" }}>
        {rows.map(([k, val]) => (
          <React.Fragment key={k}>
            <dt className="font-semibold pr-3" style={{ color: "var(--yalola-text-muted)" }}>{k}</dt>
            <dd className="tabular-nums break-words min-w-0" data-testid={`device-debug-${k.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{val}</dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
};
